import React, { useEffect } from 'react';
import { IntercomProvider, useIntercom } from 'react-use-intercom';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_ID;

/**
 * `IntercomProvider` bootea el widget al montar, pero no lo apaga al desmontar.
 * Este hijo cierra la sesión al salir de la vista para que el launcher no quede
 * flotando en el resto de la SPA (mapas, onboarding, …), igual que hace
 * HubSpotChat con su script.
 */
const IntercomShutdown = () => {
  const { shutdown } = useIntercom();
  useEffect(() => shutdown, [shutdown]);
  return null;
};

/**
 * Carga el chat de Intercom mientras el componente esté montado. Se monta solo
 * en la vista root (login unificado), donde todavía no hay usuario ni tenant:
 * el visitante entra como lead anónimo, sin atributos de identidad.
 *
 * Requiere REACT_APP_INTERCOM_ID; si falta, no hace nada (por ejemplo en tests
 * o en un build sin la variable configurada).
 * Documentación: https://github.com/devrnt/react-use-intercom
 */
const IntercomChat = () => {
  if (!INTERCOM_APP_ID) return null;

  return (
    <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
      <IntercomShutdown />
    </IntercomProvider>
  );
};

export default IntercomChat;
